import { styled } from '@mui/material/styles';
import { Div } from '../../Atoms/Div';

export const Overflow = styled(Div)`
  display: flex;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  overflow: hidden;
  white-space: nowrap;
`;
